import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui';

function BackHomeButton({ className = '' }) {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="sm"
      className={`rg-page-home-link ${className}`.trim()}
      onClick={() => navigate('/')}
      aria-label="Volver al inicio"
    >
      <i className="bi bi-house-door" aria-hidden />
      Inicio
    </Button>
  );
}

export default BackHomeButton;
